import { ReactElement } from "react"

import AmendDeviceForm from "../../../../components/devices/ttr/amendDeviceForm"
import NewAmendmentProvider from "../../../../components/devices/ttr/providers/newAmendmentProvider"

/**
 * Webpage for allowing users to amend a device.
 * Similar to `<PublishDevice />` but uses a different context
 */
const AmendDevice = (): ReactElement => (
    <NewAmendmentProvider>
        <AmendDeviceForm />
    </NewAmendmentProvider>
)

export default AmendDevice
